import { render, staticRenderFns } from "./thirdShare.vue?vue&type=template&id=97310932&scoped=true"
import script from "./thirdShare.vue?vue&type=script&lang=js"
export * from "./thirdShare.vue?vue&type=script&lang=js"
import style0 from "./thirdShare.vue?vue&type=style&index=0&id=97310932&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97310932",
  null
  
)

export default component.exports